import React, {useState} from 'react';
import CarrotUp from './icons/carrot-up';
import CarrotDown from './icons/carrot-down';

const FaqQuestion = ({faq}) => {
const [faqOpen, setFaqOpen] = useState(false);

const handleFaqToggle = () => {
  setFaqOpen(!faqOpen);
}

  return ( 
    <div className="bg-amber-50 rounded-[6px] my-2 px-4 py-2">
      <div role="button" className="flex flex-row justify-between cursor-pointer" onClick={handleFaqToggle}>
        <div className="max-w-[85%]">
          <span className="font-bold">{faq.question}</span>
        </div>
        <span className="p-2 w-[40px]">
          {faqOpen ? <CarrotUp /> : <CarrotDown />}
        </span>
      </div>
      <div className={`${faqOpen ? "block" : "hidden"}`}>
        <p>{faq.answer}</p>    
      </div>
    </div>
   );
}
 
export default FaqQuestion;